<template>
    <div class="lesson-preparation">
        <h3 class="title">Voorbereiding</h3>
        <design-2021-apprentice-display-html-component :html-content="preparationIn">
        </design-2021-apprentice-display-html-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-lesson-manual-lesson-preparation-component',
    props: {
        preparationIn: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss"></style>
